import { Address, fromNano, toNano } from '@ton/core';

const surfaces = { private: 'p', inline: 'i', ephemeral: 'e', guest: 'g', mini_app: 'm' } as const;
export type LinkSurface = keyof typeof surfaces;

/** Telegram startapp permits only base64url characters. Never embed raw addresses with colons. */
export function tokenStartParam(curve: string): string {
  return `t_${Address.parse(curve).toString({ urlSafe: true, bounceable: true })}`;
}

export function buyStartParam(curve: string, amount: string, surface: LinkSurface): string {
  if (!/^\d+(?:\.\d+)?$/.test(amount)) throw new Error('Invalid buy amount');
  return `b_${Address.parse(curve).toString({ urlSafe: true, bounceable: true })}_n${toNano(amount).toString(36)}_${surfaces[surface]}`;
}

export function buyCustomStartParam(curve: string, surface: LinkSurface): string {
  return `b_${Address.parse(curve).toString({ urlSafe: true, bounceable: true })}_c_${surfaces[surface]}`;
}

export function parseStartParam(value: string): { curve: string; amount?: string; surface?: LinkSurface } | null {
  try {
    if (value.startsWith('t_')) return { curve: Address.parse(value.slice(2)).toRawString() };
    const buy = /^b_(.{48})_(n[0-9a-z]+|\d+(?:d\d+)?|c)_([piegm])$/.exec(value);
    if (buy) return {
      curve: Address.parse(buy[1]!).toRawString(), amount: buy[2] === 'c' ? ''
        : buy[2]!.startsWith('n') ? fromNano([...buy[2]!.slice(1)].reduce(
          (value, digit) => value * 36n + BigInt(parseInt(digit, 36)), 0n)) : buy[2]!.replace('d', '.'),
      surface: (Object.keys(surfaces) as LinkSurface[]).find((key) => surfaces[key] === buy[3]),
    };
    // Retain compatibility with already-published cards, including raw addresses.
    const legacy = /^buy:(.+):(\d+(?:\.\d+)?):(private|inline|ephemeral|guest|mini_app)$/.exec(value);
    if (legacy) return { curve: Address.parse(legacy[1]!).toRawString(), amount: legacy[2], surface: legacy[3] as LinkSurface };
    return { curve: Address.parse(value.replace(/^token:/, '')).toRawString() };
  } catch { return null; }
}
